import React from 'react';
import PortfolioSide from '../../components/portfolioSide/PortfolioSide';

const Portfolio = () => (
    <>
        <PortfolioSide />
    </>
);

export default Portfolio;